import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"
import {
  faCreditCard,
  faExclamationCircle,
  faFile,
  faFolder,
  faQuestionCircle,
  faTag
} from "@fortawesome/pro-regular-svg-icons"
import { faAngleDown, faAngleUp, faWrench } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Accordion, AccordionContent, AccordionTitle, Divider } from "semantic-ui-react"
import needHelpInfoIcon from "../../../images/need-help-info-icon.svg"
import { isEbayTireOrder } from "../../../v1/helpers/orderHelpers"
import { getTireShopOrderDetails } from "../../../v1/actions/bookingConfirmation"

const ViewShopInstructions = ({
  vehicle,
  user,
  history,
  getTireShopOrderDetails,
  orders,
  match
}) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [tireOrder, setTireOrder] = React.useState(null)
  const { orderId } = match?.params
  const order = orders?.find((order) => order.id === Number(orderId))

  const handleTitleClick = (e, titleProps) => {
    const { index } = titleProps
    const newIndex = activeIndex === index ? -1 : index
    setActiveIndex(newIndex)
  }

  const orderServices = order?.order_services?.map((service) => {
    return (
      <div className="vsi-services-list-div">
        <p className="vsi-services-list">&bull; {service?.name}</p>
        <p className="vsi-services-list">
          {!isEbayTireOrder(order) && service?.override_total_with_promotional_discount === 0
            ? "Priced at shop"
            : `$${Number(service?.override_total_with_promotional_discount).toFixed(2)}`}
        </p>
      </div>
    )
  })

  let vehicleDetails = ""
  if (vehicle?.year > 0) {
    vehicleDetails += vehicle?.year + " "
  }
  if (vehicle?.make !== null) {
    vehicleDetails += vehicle?.make + " "
  }
  if (vehicle?.model !== null) {
    vehicleDetails += vehicle?.model
  }

  useEffect(() => {
    async function fetchTireOrder() {
      if (order?.is_tire_order && order?.id) {
        const res = await getTireShopOrderDetails(user, order.id - 1)
        if (res.result) {
          setTireOrder(res.result.tire_shop_order)
        }
      }
    }
    fetchTireOrder()
  }, [order])

  const tire = tireOrder?.tire_orders?.[0]

  if (!order) {
    return <div className="view-shop-instructions-container"></div>
  }

  return (
    <div className="view-shop-instructions-container">
      <div className="container-header">
        <FontAwesomeIcon icon={faArrowLeft} size="16px" onClick={() => history.goBack()} />
        <div className="container-header-title">
          <img src={needHelpInfoIcon} alt="Help info" />
          <p style={{ fontWeight: "bold", fontSize: "18px", color: "#252525" }}>
            Need help at the shop?
          </p>
        </div>
        <FontAwesomeIcon icon={faArrowLeft} size="16px" style={{ opacity: "0" }} />
      </div>
      <div className="view-shop-instructions-accordion-container">
        <Accordion className="view-shop-instructions-accordion">
          <AccordionTitle
            active={activeIndex === 0}
            index={0}
            onClick={handleTitleClick}
            className="view-shop-instructions-accordion-title"
          >
            <div className="vsi-accordion-title-text-container">
              <div className="vsi-accordion-title-text">
                <FontAwesomeIcon icon={faFile} style={{ paddingRight: "10px" }} color="#E95832" />
                <div>
                  <p style={{ margin: "0" }}>
                    <b>First, say you're with CarAdvise.</b> Show this guidance if needed.
                  </p>
                  {isEbayTireOrder(order) && order?.third_party_id && (
                    <p style={{ margin: "0" }}>
                      <b>eBay order ID: </b>
                      {order?.third_party_id}
                    </p>
                  )}
                </div>
              </div>
              <FontAwesomeIcon icon={activeIndex === 0 ? faAngleUp : faAngleDown} />
            </div>
          </AccordionTitle>
          <AccordionContent active={activeIndex === 0}>
            <div className="vsi-guidance-text-container">
              <FontAwesomeIcon icon={faFolder} className="vsi-icon" />
              <div className="vsi-guidance-text-header">
                <b>CarAdvise Fleet Account Customer</b>
                <p style={{ margin: "0" }}>
                  Process work order via <b>Autointegrate</b>
                </p>
                {order?.company?.national_account_number && (
                  <p style={{ margin: "0" }}>
                    Account Number: <b>{order?.company?.national_account_number}</b>
                  </p>
                )}
              </div>
            </div>
            <Divider className="vsi-hr" />
            <div className="vsi-guidance-text-container">
              <FontAwesomeIcon icon={faExclamationCircle} className="vsi-icon" />
              <div className="vsi-guidance-text-header">
                <b>Await text for approval</b>
                <div style={{ display: "flex" }}>
                  Do not begin work until customer approves the final invoice in their app.
                </div>
              </div>
            </div>
            <Divider className="vsi-hr" />
            <div className="vsi-guidance-text-container">
              <FontAwesomeIcon icon={faCreditCard} className="vsi-icon" />
              <div className="vsi-guidance-text-header">
                <b>Payment notice</b>
                <div style={{ display: "flex" }}>Do not charge the customer directly.</div>
              </div>
            </div>
            <Divider className="vsi-hr" />
            <div className="vsi-guidance-text-container">
              <FontAwesomeIcon icon={faTag} className="vsi-icon" />
              <div className="vsi-guidance-text-header">
                <b>Partnership discounts are automatic</b>
                <div style={{ display: "flex" }}>
                  All eligible discounts are applied by CarAdvise. No manual calculations needed.
                </div>
              </div>
            </div>
          </AccordionContent>
        </Accordion>
      </div>
      <div className="view-shop-instructions-accordion-container">
        <Accordion className="view-shop-instructions-accordion">
          <AccordionTitle
            active={activeIndex === 1}
            index={1}
            onClick={handleTitleClick}
            className="view-shop-instructions-accordion-title"
          >
            <div className="vsi-accordion-title-text-container">
              <div>
                <FontAwesomeIcon icon={faWrench} style={{ paddingRight: "10px" }} color="#E95832" />
                <b>Service Details</b>
              </div>
              <FontAwesomeIcon icon={activeIndex === 1 ? faAngleUp : faAngleDown} />
            </div>
          </AccordionTitle>
          <AccordionContent active={activeIndex === 1}>
            <div className="vsi-accordion-content">
              <p className="vsi-accordion-content-text">
                <b>Customer:</b> {user?.firstName} {user?.lastName}
              </p>
              <p className="vsi-accordion-content-text">
                <b>Vehicle:</b> {vehicleDetails}
              </p>
              {isEbayTireOrder(order) && (
                <>
                  {order?.tire_details && (
                    <p className="vsi-accordion-content-text">
                      <p style={{ margin: 0, lineHeight: "30px" }}>
                        <b>Tires from eBay:</b> {order?.tire_details}
                      </p>
                    </p>
                  )}
                </>
              )}
              {order?.is_tire_order && tireOrder && tire && (
                <p className="vsi-accordion-content-text">
                  <b>Tires:</b> {tire?.quantity} {tire?.brand} {tire?.tire_model}{" "}
                  {tire?.tire_details}
                </p>
              )}
              <b style={{ lineHeight: "25px" }}>Requested services:</b>
              {orderServices}
              <Divider />
              <div className="vsi-estimated-div">
                <b>Estimated subtotal:</b>
                <b>
                  {!isEbayTireOrder(order) && order?.estimated_sub_total === 0
                    ? "Priced at shop"
                    : `$${Number(order.estimated_total).toFixed(2)}`}
                </b>
              </div>
            </div>
          </AccordionContent>
        </Accordion>
      </div>
      <div className="vsi-help-text">
        <FontAwesomeIcon
          icon={faQuestionCircle}
          style={{ paddingRight: "5px", paddingTop: "2px" }}
        />
        <p style={{ margin: 0 }}>
          {isEbayTireOrder(order)
            ? "Problem at the shop? We're here to help. "
            : "Having trouble scheduling? We're here to help. "}
          Call <b>(844) 923-8473.</b>
        </p>
      </div>
    </div>
  )
}

function mapStateToProps(state) {
  const user = state.user
  let activeVehicle = user.vehicles && user.vehicles.find((v) => v.id == user.activeVehicleId)

  return {
    vehicle: activeVehicle,
    user: user,
    orders: user.active_orders
  }
}

export default connect(mapStateToProps, {
  getTireShopOrderDetails
})(ViewShopInstructions)
